// export const backendURL = "http://localhost:8000/"
// export const backendURL = "https://full-stack-e-commerceproject-production.up.railway.app/"
export const backendURL = "https://full-stack-e-commerce-project-qyre.onrender.com/"